import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import { CATEGORY_MEDIA_GET, CATEGORY_MEDIA_RESET } from '../actions/utils';
// import storage from '../../../utils/storage';

const initialState = {
  categoryMedia: {},
};

const userReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case CATEGORY_MEDIA_GET._SUCCESS: {
        draft.categoryMedia = action?.response || {};
        break;
      }

      case CATEGORY_MEDIA_RESET: {
        draft.categoryMedia = initialState.categoryMedia;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default userReducer;
